import { useColors } from '@osmosis/react-ui/hooks/useColors';
import * as React from 'react';

/**
 * SkipForward.
 */
function SkipForward(
  props: React.SVGProps<SVGSVGElement> & { color?: string; size?: string },
) {
  const { color = 'text', size = '24px' } = props;
  const colors = useColors();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 423 478"
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit={1.41421}
      fill={colors[color] || color}
      {...props}
    >
      <path
        d="M2575.18 12271.9l-14.04-14-.72-.8c-8.4-9.6-7.94-25.3 1.48-33.9 4.64-4.2 11.03-6.4 17.26-6.3 5.27.4 10.35 2.2 14.38 5.6.72.6.87.8 1.55 1.4l58.05 58.1c.64.7.82.8 1.41 1.5 7.17 8.6 7.28 22.2 0 30.9-.59.7-.77.8-1.41 1.5l-58.21 58.2c-6.38 6.1-15.86 8.6-24.19 5.9-9.32-2.9-16.33-12-16.76-21.8-.29-6.6 2.37-13.2 7.01-18l20.52-20.5c-8.94 0-17.89 0-26.88.3-48.8 1.2-96.96 25.6-126.96 66-32.41 43.6-41.12 103.8-21.56 155.3 23.39 61.5 85.26 105.9 154.36 105.3 59.84-.5 117.9-35.5 145.43-92.1 10.74-22.1 16.29-46.5 16.32-71.3l.47-4.6c.46-1.5.77-3.1 1.37-4.5 4.83-11.6 19.64-17.9 31.37-13 7.3 3 12.81 9.8 14.34 17.5.8 4.1.47 8.1.32 12.1-1.99 57-27.9 112.6-71.49 151.1-48.39 42.7-116.76 61.7-181.65 48.7-63.98-12.9-120.9-57.3-149.13-116.8-28.08-59.1-26.83-131.3 4.62-190 34.14-63.8 102.04-108 176.23-111.6 3.39-.1 6.79-.2 10.17-.2h16.34zm38.58 142.6c15.57.2 30.55 6.7 39.78 20.8 15.4 23.6 14.07 56.1 8.9 78.5-3.31 14.3-10.55 28.6-23.73 36.4-21.27 12.6-52.18 6.3-65.7-14.7-15.01-23.4-13.9-55.4-8.8-77.9 3.23-14.3 10.31-28.5 23.25-36.4 7.82-4.7 17.14-6.7 26.3-6.7zm-82.19 111.4h.62c6.15.2 12.7 3.3 14.54 9.7 1.9 6.6-.35 14.5-6.84 17.6-2.56 1.3-5.44 1.7-8.3 1.7-20.72.1-41.43.1-62.14 0-6.21 0-13.03-2.8-15.16-9.3-2.13-6.7-.2-15 7.03-18.2 2.55-1.1 5.35-1.4 8.14-1.5h14.19v-69.3l-9.99 6.1c-5.59 3.2-13.23 2.4-17.59-3.1-5.34-6.7-4.52-17.8 3.45-22.8l28.36-17.5c4.04-2.4 8.59-4.1 13.21-4 8.66.1 16.08 7.2 16.11 16.6v94h14.37zm81.64-82.9c-3.43 0-6.9.9-9.55 3.3-6.47 5.7-7.42 15.1-8.26 23-1.82 16.9-2.56 35.5 4.15 49.7 2.4 5.1 7.2 9.1 13.66 9.1 3.23 0 6.52-.7 9.11-2.7 5.8-4.4 7.29-12.2 8.35-18.7 3-18.4 3.91-38.3-3.18-54.2-1.74-3.9-4.74-7.5-8.99-8.8-1.73-.5-3.16-.7-5.29-.7zm61.03-226.1c3.21.2 3.74.4 5.16.8 4.05 1.1 7.72 3.3 10.76 6.2l58.06 58.1c.64.7.81.8 1.41 1.5 7.16 8.6 7.28 22.2 0 30.9-.6.7-.77.8-1.41 1.5l-58.21 58.2c-6.39 6.1-15.87 8.6-24.19 5.9-9.32-2.9-16.33-12-16.76-21.8-.29-6.6 2.36-13.2 7.01-18l41.23-41.2-41.08-41.1-.73-.8c-7.72-8.8-8.05-22.9-.69-31.6 4.72-5.7 12.17-8.7 19.44-8.6z"
        fillRule="nonzero"
        transform="translate(-2347.75 -12216.9)"
      />
    </svg>
  );
}

export default SkipForward;
